import * as fromLocalStorage from "../../localStorage/localStorageReducer"

/**
 * Return the dynamic configuration value associated with the key stored in the store.
 */
export const getDynamicConfigurationValue = (state, key) =>
    fromLocalStorage.getDynamicConfigurationValue(state.localStorage, key)
